/**
 * El enlace de pago propio del cliente (`url_pago_propia_cliente`).
 *
 * Llega por la API (`payment_link`) y por la importadora sin validar, y la
 * ficha del expediente lo pinta como enlace clicable. Un `javascript:` ahí es
 * código que se ejecuta en la sesión de quien lo pulse, así que solo se acepta,
 * y solo se enlaza, lo que sea http o https. La regla vive aquí para que la
 * ficha (que decide si lo enlaza) y el backend (que decide si lo guarda) no se
 * desincronicen.
 */

/**
 * @param {unknown} value
 * @returns {boolean} true si es una URL http(s) bien formada
 */
function isPaymentLink(value) {
  if (typeof value !== 'string') return false;
  try {
    const url = new URL(value.trim());
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Normaliza lo que manda la ficha al editar: vacío borra el enlace.
 *
 *   '  '                       → { value: null }
 *   ' https://pago.cliente.es' → { value: 'https://pago.cliente.es' }
 *   'javascript:alert(1)'      → { error: '...' }
 *
 * @param {unknown} value
 * @returns {{ value: string|null } | { error: string }}
 */
function normalizePaymentLink(value) {
  if (value === null || value === undefined) return { value: null };
  if (typeof value !== 'string') return { error: 'El enlace de pago tiene que ser texto' };
  const trimmed = value.trim();
  if (!trimmed) return { value: null };
  if (!isPaymentLink(trimmed)) {
    return { error: 'El enlace de pago tiene que empezar por http:// o https://' };
  }
  return { value: trimmed };
}

module.exports = { isPaymentLink, normalizePaymentLink };
